/* eslint-disable prefer-rest-params, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-explicit-any */
import {
  connect,
  MergeProps,
  MapStateToPropsParam,
  InferableComponentEnhancerWithProps
} from 'react-redux';
import { PageState } from 'models/PageState';
import { HeaderState } from 'models/HeaderState';
import { ThunkAction, ThunkDispatch as ReduxThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';

export type ThunkDispatch = ReduxThunkDispatch<HeaderState | PageState, any, AnyAction>;

export type SideEffect<R = any> = ThunkAction<Promise<R>, HeaderState | PageState, any, AnyAction>;

type MapDispatchToPropsFunction<TDispatchProps, TOwnProps> = (
  dispatch: ThunkDispatch,
  ownProps: TOwnProps
) => TDispatchProps;

type MapDispatchToProps<TDispatchProps, TOwnProps> =
  | MapDispatchToPropsFunction<TDispatchProps, TOwnProps>
  | TDispatchProps;

type MapDispatchToPropsFactory<TDispatchProps, TOwnProps> = (
  dispatch: ThunkDispatch,
  ownProps: TOwnProps
) => MapDispatchToProps<TDispatchProps, TOwnProps>;

type MapDispatchToPropsParam<TDispatchProps, TOwnProps> =
  | MapDispatchToPropsFactory<TDispatchProps, TOwnProps>
  | MapDispatchToProps<TDispatchProps, TOwnProps>;

interface AnyExtraProps {
  [extraProps: string]: any;
}
export default function <MergedProps = any, OwnProps = any, StateProps = any>(
  _mapStateToProps?: MapStateToPropsParam<Partial<MergedProps & StateProps>, OwnProps, PageState>,
  _mapDispatchToProps?: MapDispatchToPropsParam<Partial<MergedProps & StateProps>, OwnProps>,
  _mergeProps?: MergeProps<
    MergedProps & StateProps & AnyExtraProps,
    MergedProps & StateProps,
    OwnProps,
    MergedProps
  >,
  _options?: any
): InferableComponentEnhancerWithProps<MergedProps, OwnProps> {
  return connect.apply(this, arguments);
}

export function headerConnect<MergedProps = any, OwnProps = any, StateProps = any>(
  _mapStateToProps?: MapStateToPropsParam<Partial<MergedProps & StateProps>, OwnProps, HeaderState>,
  _mapDispatchToProps?: MapDispatchToPropsParam<Partial<MergedProps & StateProps>, OwnProps>,
  _mergeProps?: MergeProps<
    MergedProps & StateProps & AnyExtraProps,
    MergedProps,
    OwnProps,
    MergedProps
  >,
  _options?: any
): InferableComponentEnhancerWithProps<MergedProps, OwnProps> {
  return connect.apply(this, arguments);
}
